import { ProductInfo } from '@/scripts/product/product-info'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ProductStickyCta extends ProductInfo {
    static override htmlSelector = 'product-sticky-cta'
    form: HTMLElement
    wrapper: HTMLElement
    submitContainer: HTMLElement
    overlay: HTMLElement
    boundBodyListener: () => void
    cta: HTMLButtonElement
    primaryCta: HTMLButtonElement
    info: ProductInfo
    constructor() {
        super()
        this.form = q.rs('[data-uc-sticky-form]', this)
        this.wrapper = q.rs('[data-uc-sticky-wrapper]', this)
        this.overlay = q.rs('[data-uc-sticky-overlay]', this)
        this.submitContainer = q.rs('[data-uc-sticky-submit-container', this)
        this.cta = q.rs('button[type="submit"]', this.submitContainer)
        this.boundBodyListener = this.bodyListener.bind(this)
        this.primaryCta = q.rs('button[type="submit"][data-source="primary"]')
        this.info = q.rs('product-info')
        this.observePrimaryCta(this.primaryCta, this.onPrimaryCtaIntersection.bind(this))
    }
    override getSiblingForm() {
        return q.os<ProductStickyCta>(`product-info[data-uc-product-id="${this.productId}"]`)
    }

    observePrimaryCta(
        cta: HTMLElement,
        onIntersection: (elements: IntersectionObserverEntry[], _: IntersectionObserver) => void
    ) {
        const ctaObserver = new IntersectionObserver(onIntersection)
        ctaObserver.observe(cta)
    }
    onPrimaryCtaIntersection(elements: IntersectionObserverEntry[], _: IntersectionObserver) {
        elements.forEach((element) => {
            if (element.isIntersecting) {
                this.hide()
            } else if (window.scrollY > 500) {
                this.show()
            }
        })
    }
    hide() {
        this.setAttribute('aria-hidden', 'true')
        //removeTrapFocus()
    }
    show() {
        this.setAttribute('aria-hidden', 'false')
        //trapFocus(this.form, this.cta)
    }
    hideForm(event: Event) {
        event.preventDefault()
        this.form.setAttribute('aria-hidden', 'true')
        this.form.style.maxHeight = '0px'
        this.overlay.classList.remove('active')
        window.setTimeout(() => {
            this.overlay.style.display = 'none'
        }, 301)
        document.documentElement.removeEventListener('click', this.boundBodyListener)
    }
    bodyListener(event: Event) {
        const currentTarget = q.rct(event)
        const target = q.rt(event)
        if (
            this.variantRadios?.contains(currentTarget) ||
            this.variantRadios?.contains(target) ||
            this.submitContainer.contains(target) ||
            this.submitContainer.contains(currentTarget)
        ) {
            return
        }
        this.hideForm(event)
    }
}
